import { Record } from 'immutable';

const PropertyConfigLookupRecord = Record({
  chain: null,
  brand: null,
  propertyId: null
});

export class PropertyConfigLookup extends PropertyConfigLookupRecord {
  chain: string;
  brand: string;
  propertyId: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/property-config-lookup.ts